<div  >
    <label>{{label|translate}}</label>
    <p class="displayValue" >{{value|translate}}</p>
</div>
